// components/attendance/components/StrangerTableRow.js
import React, { useState } from 'react';
import Image from '../../../components/appImage';
import Icon from '../../../components/appIcon';
import Button from '../../../components/ui/button';
const BACKEND_URL = import.meta.env.VITE_API_URL;

const StrangerTableRow = ({
  stranger,
  onIdentify,
  onMarkAsVisitor,
  onDismiss,
  onActivate,
  onViewDetails,
  onViewAttendance,
  onSwitch,
  isSelected = false,
  onSelect
}) => {
  const [isProcessing, setIsProcessing] = useState(false);

  const handleAction = async (action, data) => {
    setIsProcessing(true);
    try {
      await action(data);
    } finally {
      setIsProcessing(false);
    }
  };

  const getConfidenceColor = (confidence) => {
    if (confidence >= 90) return 'text-success';
    if (confidence >= 70) return 'text-warning';
    return 'text-error';
  };

  const getStatusBadge = (status) => {
    const statusConfig = {
      new: { color: 'bg-accent text-accent-foreground', label: 'New' },
      reviewed: { color: 'bg-secondary text-secondary-foreground', label: 'Reviewed' },
      identified: { color: 'bg-success text-success-foreground', label: 'Identified' },
      visitor: { color: 'bg-warning text-warning-foreground', label: 'Visitor' },
      inactive: { color: 'bg-muted text-muted-foreground', label: 'Inactive' }
    };

    const config = statusConfig?.[status] || statusConfig?.new;
    return (
      <span className={`px-2 py-1 rounded-full text-xs font-medium ${config?.color}`}>
        {config?.label}
      </span>
    );
  };

  // Handle image URL - check if it's already a full URL
  console.log("stranger",`${BACKEND_URL}${stranger?.originalData?.images[0]?.imagePath}`)
  const imageUrl = stranger?.originalData?.images[0]?.imagePath
    
    ? `${BACKEND_URL}${stranger?.originalData?.images[0]?.imagePath}`
    : stranger.imageUrl;
  console.log("imageUrl",imageUrl)
  return (
    <tr className={`border-b border-border hover:bg-muted/50 ${isSelected ? 'bg-muted/30' : ''}`}>
      {/* Selection Checkbox */}
      <td className="p-3">
        <input
          type="checkbox"
          checked={isSelected}
          onChange={(e) => onSelect(stranger?.id, e?.target?.checked)}
          className="w-4 h-4 text-primary bg-card border-border rounded focus:ring-primary"
        />
      </td>
      
      {/* Image */}
      <td className="p-3">
        <div className="w-10 h-10 bg-muted rounded-full overflow-hidden">
          <Image
            src={imageUrl}
            alt={`Stranger detected at ${stranger?.location}`}
            className="w-full object-fit"
          />
        </div>
      </td>
      
      {/* ID */}
      <td className="p-3">
        <div className="font-medium text-foreground">{stranger?.id}</div>
      </td>
      
      {/* Name */}
      <td className="p-3">
        <div className="font-medium text-foreground">
          {stranger?.first_name} {stranger?.last_name}
        </div>
        <div className="text-sm text-muted-foreground">{stranger?.email}</div>
      </td>
      
      {/* Location */}
      <td className="p-3">
        <div className="flex items-center space-x-2">
          <Icon name="MapPin" size={14} className="text-muted-foreground" />
          <span className="text-sm text-foreground">{stranger?.location}</span>
        </div>
        <div className="text-xs text-muted-foreground">{stranger?.cameraName}</div>
      </td>
      
      {/* Detected At */}
      <td className="p-3">
        <div className="text-sm text-foreground">
          {stranger.detectedAt instanceof Date
            ? stranger.detectedAt.toLocaleDateString()
            : new Date(stranger.detectedAt).toLocaleDateString()}
        </div>
        <div className="text-xs text-muted-foreground">
          {stranger.detectedAt instanceof Date
            ? stranger.detectedAt.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
            : new Date(stranger.detectedAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
        </div>
      </td>
      
      {/* Detection Count */}
      {/* <td className="p-3">
        <div className="flex items-center space-x-2">
          <Icon name="Eye" size={14} className="text-muted-foreground" />
          <span className="text-sm text-foreground">{stranger?.detectionCount}</span>
        </div>
      </td>
       */}
      {/* Status */}
      <td className="p-3">
        {getStatusBadge(stranger?.status)}
      </td>
      
      {/* Actions */}
      <td className="p-3">
        <div className="flex items-center space-x-2">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => onViewDetails(stranger)}
            title="View Details"
          >
            <Icon name="Eye" size={16} />
          </Button>
          
          {stranger?.status === 'inactive' ? (
            <Button
              variant="ghost"
              size="sm"
              onClick={() => handleAction(onActivate, stranger.id)}
              disabled={isProcessing}
              title="Activate"
            >
              <Icon name="Check" size={16} />
            </Button>
          ) : (
            <Button
              variant="ghost"
              size="sm"
              onClick={() => handleAction(onDismiss, stranger.id)}
              disabled={isProcessing || stranger?.status === 'inactive'}
              title="Dismiss"
            >
              <Icon name="X" size={16} />
            </Button>
          )}
          
          <Button
            variant="ghost"
            size="sm"
            onClick={() => onViewAttendance(stranger)}
            title="View Attendance"
          >
            <Icon name="Calendar" size={16} />
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => onSwitch(stranger)}
            title="Switch to Employee"
          >
            <Icon name="CheckCircle" size={16} />
          </Button>
        </div>
      </td>
    </tr>
  );
};

export default StrangerTableRow;